import React from 'react';
import Button from '../../../Button';
import TextButton from '../../../TextButton';
import { dataHooks } from '../../Notification.constants';
import { classes } from '../../Notification.st.css';
import { ActionButtonProps } from '../../Notification.types';

const ActionButton: React.FC<ActionButtonProps> = props => {
  const { children } = props;

  if (props.type === 'textLink') {
    return (
      <TextButton
        className={classes.textLink}
        underline="always"
        skin="light"
        as="a"
        href={props.link}
        target={props.target ?? '_self'}
        dataHook={dataHooks.notificationCtaButton}
        onClick={props.onClick}
      >
        {children}
      </TextButton>
    );
  }

  return (
    <Button
      className={classes.button}
      type="button"
      size="small"
      skin="transparent"
      dataHook={dataHooks.notificationCtaButton}
      onClick={props.onClick}
    >
      {children}
    </Button>
  );
};

ActionButton.displayName = 'Notification.ActionButton';

export default ActionButton;
